import {
  TextControl,
  PanelBody,
  PanelRow,
  ToggleControl,
} from '@wordpress/components';

import { __ } from '@wordpress/i18n';
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
  InnerBlocks,
  useBlockProps,
  InspectorControls,
  BlockControls,
} from '@wordpress/block-editor';

// useEffect
import { useEffect } from '@wordpress/element';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @param {Object}   props               Properties passed to the function.
 * @param {Object}   props.attributes    Available block attributes.
 * @param {Function} props.setAttributes Function that updates individual attributes.
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
  const {
    counterStart,
    counterEnd,
    counterCurrency,
    counterDecimals,
    counterAppend,
    counterSeperator,
    counterDelay,
    flexStyle,
    flexClass,
    bitePreset,
  } = attributes;

  const onChangeCounterStart = (counterStart) => {
    setAttributes({
      counterStart: counterStart,
    });
  };

  const onChangeCounterEnd = (counterEnd) => {
    setAttributes({ counterEnd: counterEnd });
  };

  const onChangeCounterCurrency = (counterCurrency) => {
    setAttributes({
      counterCurrency: counterCurrency,
    });
  };

  const onChangeCounterDecimals = (counterDecimals) => {
    setAttributes({
      counterDecimals: counterDecimals,
    });
  };

  const onChangeCounterAppend = (counterAppend) => {
    setAttributes({
      counterAppend: counterAppend,
    });
  };

  const onChangeCounterSeperator = (counterSeperator) => {
    setAttributes({
      counterSeperator: counterSeperator,
    });
  };

  const onChangeCounterDelay = (counterDelay) => {
    setAttributes({
      counterDelay: counterDelay,
    });
  };

  // flex classes on inner element
  const flexCallback = (flexObj, flexClass) => {
    setAttributes({
      flexStyle: flexObj,
      flexClass: flexClass,
    });
  };

  const newClass = ['bf_flex', flexClass];
  const newClasses = newClass.join(' ');
  const blockProps = useBlockProps({ className: newClasses });

  return (
    <div {...blockProps}>
      <span
        data-purecounter-start={counterStart}
        data-purecounter-end={counterEnd}
        data-purecounter-currency={counterCurrency}
        data-purecounter-decimals={counterDecimals}
        data-purecounter-seperator={counterSeperator}
        className="purecounter"
      >
        {counterStart}
      </span>
      <span>{counterAppend}</span>
      <InspectorControls>
        <PanelBody
          title={__('Counter Settings', 'blockbite')}
          initialOpen={true}
        >
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('Start', 'blockbite')}
                value={counterStart}
                onChange={onChangeCounterStart}
                help={__('Add Start', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('End', 'blockbite')}
                value={counterEnd}
                onChange={onChangeCounterEnd}
                help={__('Add End', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('Currency', 'blockbite')}
                value={counterCurrency}
                onChange={onChangeCounterCurrency}
                help={__('Add Currency', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('Decimals', 'blockbite')}
                value={counterDecimals}
                onChange={onChangeCounterDecimals}
                help={__('Add Currency', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <ToggleControl
                label={__('Seperator', 'blockbite')}
                checked={counterSeperator}
                onChange={onChangeCounterSeperator}
                help={__('Add Seperator', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('Delay', 'blockbite')}
                value={counterDelay}
                onChange={onChangeCounterDelay}
                help={__('Add Delay', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
          <PanelRow>
            <fieldset>
              <TextControl
                label={__('Append', 'blockbite')}
                value={counterAppend}
                onChange={onChangeCounterAppend}
                help={__('Add text after', 'blockbite')}
              />
            </fieldset>
          </PanelRow>
        </PanelBody>
      </InspectorControls>
    </div>
  );
}
